/* unplugin-vue-components disabled */import { render } from "./cellInfo.vue?vue&type=template&id=47c08422&scoped=true"
import script from "./cellInfo.vue?vue&type=script&lang=js"
export * from "./cellInfo.vue?vue&type=script&lang=js"

import "./cellInfo.vue?vue&type=style&index=0&id=47c08422&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47c08422"]])

export default __exports__